import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { checkingIfImagesAreRequired } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/single-photo-product-options/single-photo-product-options.component';
import { addProductInPackageToBasketAction } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/actions';
import { select, Store } from '@ngrx/store';
import {
  selectPackagesInBasket,
  selectPackagesInShop,
  selectProductsList,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';

@Injectable({
  providedIn: 'root',
})
export class CheckingForMatchingPhotosInProductService {
  packagesInBasket$ = this.store.pipe(select(selectPackagesInBasket));
  packagesInShop$ = this.store.pipe(select(selectPackagesInShop));
  productsInShop$ = this.store.pipe(select(selectProductsList));

  constructor(private store: Store) {}
  checkingForMatchingPhotosInProduct(packageInBasketId) {
    this.packagesInBasket$.pipe(first()).subscribe((packagesInBasket) => {
      this.packagesInShop$.pipe(first()).subscribe((packagesInShop) => {
        this.productsInShop$.pipe(first()).subscribe((productsInShop) => {
          const packageInBasket = packagesInBasket.find(
            (p) => p.packageInBasketId === packageInBasketId
          );
          const packageInShop = packagesInShop.package.find(
            ({ packageId }) => packageId === packageInBasket.packageId
          );
          const photoIdList: Array<{ photoId: string }> = [];
          packageInBasket.print.forEach(({ photoId }) => {
            if (!photoIdList.find((value) => value.photoId === photoId)) {
              photoIdList.push({ photoId });
            }
          });
          packageInBasket.file.forEach(({ photoId }) => {
            if (!photoIdList.find((value) => value.photoId === photoId)) {
              photoIdList.push({ photoId });
            }
          });
          console.log('Zdjęcia możliwe w produkcie w pakiecie', photoIdList);
          packageInBasket.product
            .filter(
              ({ productInPackageId }) =>
                packageInShop.productConfig.find(
                  (p) => p.productInPackageId === productInPackageId
                ).mode === 'AllImagesFromPackage'
            )
            .forEach((productInBasket) => {
              packageInShop.productConfig.find(
                ({ productInPackageId }) =>
                  productInPackageId === productInBasket.productInPackageId
              );
              const numberOfPhotos = checkingIfImagesAreRequired(
                productsInShop,
                productInBasket.productId,
                productInBasket.config
              );
              if (numberOfPhotos.imagesRequired) {
                let newPhoto = false;
                photoIdList.forEach(({ photoId }) => {
                  if (
                    !productInBasket.photos.find((p) => p.photoId === photoId)
                  ) {
                    newPhoto = true;
                  }
                });
                if (
                  photoIdList.length === 0 &&
                  productInBasket.photos.length > 0
                ) {
                  newPhoto = true;
                }
                switch (true) {
                  case numberOfPhotos.requiredImages.min >=
                    photoIdList.length && !!newPhoto:
                    console.log('zamiana zdjęć w produkcie');
                    this.store.dispatch(
                      addProductInPackageToBasketAction({
                        packageInBasketId,
                        product: {
                          ...productInBasket,
                          photos: photoIdList,
                        },
                      })
                    );
                    break;
                  case numberOfPhotos.requiredImages.min < photoIdList.length &&
                    productInBasket.photos.length > 0 &&
                    !productInBasket.photosAddedByCustomer:
                    console.log('usunięcie zdjęć z produktu');
                    this.store.dispatch(
                      addProductInPackageToBasketAction({
                        packageInBasketId,
                        product: {
                          ...productInBasket,
                          photos: [],
                        },
                      })
                    );
                    break;
                }
              }
            });
        });
      });
    });
  }
}
